export const environment = {
  production: true,
  useHash: false,
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts